import {
  COVERTREE_EMAIL_ADDRESS,
  COVERTREE_PHONE_NUMBER,
} from "@covertree/consts";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Button } from "@covertree/ui";

import { useLocation, useNavigate } from "react-router-dom";
import { moveBackInPathname } from "@utils";
import { resetPolicyTypeForm } from "@redux/coverages/coveragesSlice";
import useAppDispatch from "@redux/hooks/useAppDispatch";

export default function PolicyNotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(resetPolicyTypeForm());
    navigate({
      pathname: moveBackInPathname(location.pathname, 3),
    });
  };

  return (
    <Grid
      container
      display="flex"
      direction="column"
      gap={5}
      alignItems="flex-start"
      justifyContent="space-around">
      <img src="/images/icons/cross.webp" alt="cross" width={80} />
      <Grid item xs={12}>
        <Typography fontSize={32}>Policy Not Found</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={20}>
          Your policy was not found. Please call a CoverTree agent at{" "}
          <Typography component="span" color="secondary.main">
            {COVERTREE_PHONE_NUMBER}
          </Typography>{" "}
          or email us at{" "}
          <Typography component="span" color="secondary.main">
            {COVERTREE_EMAIL_ADDRESS}
          </Typography>
        </Typography>
      </Grid>
      <Button onClick={handleClose}>Close</Button>
    </Grid>
  );
}
